// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d743408a","186":"c638dbd5","225":"309fb4b8","272":"e785e551","372":"dc7ac93d","377":"987a533f","738":"5e6cf842","841":"9f27e1c2","856":"1d188b6f"}[chunkId] + ".chunk.js";
};